export default __webpack_public_path__ + "static/12.01-5bbfea6463549615ed5bf800aa2f014f.png";